import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, effect, inject, signal, untracked } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';
import {
  TableLazyLoadEvent,
  TableModule,
  TableRowSelectEvent,
} from 'primeng/table';
import { LeverandoerOpkraevningService } from '../leverandoer-opkraevning.service';
import { LeverandoerRisikoOpkraevningDatasource } from './leverandoer-risiko-opkraevning.datasource';
import { Dialog } from 'primeng/dialog';
import { RisikoOpkraevningDetailComponent } from '../../risikoopkraevning-opkraevninger/opkraevning-detail/risiko-opkraevning-detail.component';
import { RisikoOpkraevning } from '@features/risikoopkraevning/risiko-opkraevning.model';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-leverandoer-opkraevning-detail',
  imports: [
    DatePipe,
    DecimalPipe,
    Dialog,
    Button,
    TableModule,
    TableRowDirective,
    KeepScrollPositionDirective,
    RisikoOpkraevningDetailComponent,
  ],
  templateUrl: './leverandoer-opkraevning-detail.component.html',
  styleUrl: './leverandoer-opkraevning-detail.component.css',
})
export class LeverandoerOpkraevningDetailComponent {
  leverandoerOpkraevningService = inject(LeverandoerOpkraevningService);
  risikoOpkraevningDatasource = inject(LeverandoerRisikoOpkraevningDatasource);
  risikoOpkraevninger = this.risikoOpkraevningDatasource.data;
  visRisikoOpkraevning = signal(false);
  risikoOpkraevning = signal<RisikoOpkraevning | undefined>(undefined);

  constructor() {
    effect(() => {
      const leverandoerOpkraevning =
        this.leverandoerOpkraevningService.selectedLeverandoerOpkraevning();
      if (leverandoerOpkraevning) {
        untracked(() => {
          this.risikoOpkraevningDatasource.searchParams.set({
            leverandoerOpkraevningId: leverandoerOpkraevning.id,
          });
          this.risikoOpkraevningDatasource.loadData();
        });
      }
    });
  }

  onRowSelect(event: TableRowSelectEvent) {
    const risikoOpkraevning = event.data;
    this.risikoOpkraevning.set(risikoOpkraevning);
    this.visRisikoOpkraevning.set(true);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.risikoOpkraevningDatasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }

  onClickExport(leverandoerOpkraevningId: number) {
    this.leverandoerOpkraevningService.exportData(leverandoerOpkraevningId);
  }

  onClickHentFaktura(leverandoerOpkraevningId: number) {
    this.leverandoerOpkraevningService.hentFaktura(leverandoerOpkraevningId);
  }
}
